<template>
  <div class="sidebar-logo-container" :class="{'collapse':collapse}">
    <transition name="sidebarLogoFade">
      <router-link v-if="collapse" key="collapse" class="sidebar-logo-link" to="/">
        <img :src="logo_collapse" class="sidebar-logo">
      </router-link>
      <router-link v-else key="expand" class="sidebar-logo-link" to="/">
        <el-col :span="8"><img :src="logo" class="sidebar-logo"></el-col>
        <el-col :span="16" class="sidebar-text">
        <div>{{ this.title }}</div>
        <div class="subtitle">{{ this.subtitle }}</div>
        </el-col>
      </router-link>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      title: `${process.env.UNIVERSITY_NAME}`,
      subtitle: `${process.env.UNIVERSITY_NAME_EN}`,
      logo: require('@/assets/logo/logo.png'),
      logo_collapse: require('@/assets/logo/logo_collapse.png')
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: #032d44;
  text-align: center;
  overflow: hidden;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;

    & .sidebar-logo {
      width: auto;
      height: 30px;
      vertical-align: middle;
      margin-right: 12px;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #fff;
      font-weight: 600;
      line-height: 50px;
      font-size: 20px;
      font-family: $font-family;
      vertical-align: middle;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0;
    }
  }
  .sidebar-text {
    color: #ffffff;
    text-align: left;
    margin-top: 12px;
    line-height: 14px;
    font-size: 8px;
    .subtitle {
      font-size: 9px;
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layouts/components/Sidebar/Logo.vue